module.exports = __webpack_public_path__ + "img/services.ac217ec2.png";